export const PAGE_NAME = {
  notFound: '*',
  main: '',
  signinHome: 'signin',
  signin: 'signin/email',
  signup: 'signup',
  emailVerification: 'email-verification',
  signupSuccess: 'signup-success',
  changePassword: 'change-password',
  resetPassword: 'reset-password',
  passwordSuccess: 'password-success',
  chat: 'chat',
  chatList: 'chat-list',
  createChatRoom: 'new-chat',
  createNewCharacter: 'new-character',
  editCharacter: 'edit-character',
  chatGenerate: 'chat-generate',
  createGroupChat: 'new-group',
  myPage: 'myPage',
  profile: 'profile',
  settings: 'settings',
  report: 'report',
  groupChat: 'group',
  moreOneOnOne: 'more',
  searchRoom: 'search',
  account: 'account',
  termsOfService: 'terms-service',
  privacyPolicy: 'privacy-policy',
  asset: 'asset',
  subscription: 'subscription',
  characterResult: 'character',
  subscriptionWaiting: 'waiting',
  terms: 'terms',
  privacy: 'privacy',
  characterDetails: 'character/details',
  explore: 'explore',
  mystery: 'mystery',
  concept: 'concept',
  purchase: 'concept',
  missionGame: 'mission',
  missionResult: 'result',
  missionChat: 'chat',
} as const;

export const PAGE_ROUTE = {
  MAIN: `/${PAGE_NAME.main}`,
  SIGNIN_HOME: `/${PAGE_NAME.signinHome}`,
  SIGNIN: `/${PAGE_NAME.signin}`,
  SIGNUP: `/${PAGE_NAME.signup}`,
  SIGNUP_SUCCESS: `/${PAGE_NAME.signupSuccess}`,
  EMAIL_VERIFICATION: `/${PAGE_NAME.emailVerification}`,
  CHANGE_PASSWORD: `/${PAGE_NAME.changePassword}`,
  RESET_PASSWORD: `/${PAGE_NAME.resetPassword}`,
  PASSWORD_SUCCESS: `/${PAGE_NAME.passwordSuccess}`,
  CHAT: `/${PAGE_NAME.chat}`,
  CHAT_LIST: `/${PAGE_NAME.chatList}`,
  CREATE_CHATROOM: `/${PAGE_NAME.createChatRoom}`,
  CREATE_NEW_CHARACTER: `/${PAGE_NAME.createNewCharacter}`,
  EDIT_CHARACTER: `/${PAGE_NAME.editCharacter}`,
  CHAT_GEN: `/${PAGE_NAME.chatGenerate}`,
  CREATE_GROUP_CHAT: `/${PAGE_NAME.createGroupChat}`,
  MYPAGE: `/${PAGE_NAME.myPage}`,
  PROFILE: `/${PAGE_NAME.profile}`,
  SETTINGS: `/${PAGE_NAME.settings}`,
  REPORT: `/${PAGE_NAME.report}`,
  GROUP_CHAT: `/${PAGE_NAME.groupChat}`,
  MORE_ONE_ON_ONE: `/${PAGE_NAME.moreOneOnOne}`,
  SEARCH_ROOM: `/${PAGE_NAME.searchRoom}`,
  ACCOUNT: `/${PAGE_NAME.account}`,
  TERMS_OF_SERVICE: `/${PAGE_NAME.termsOfService}`,
  PRIVACY_POLICY: `/${PAGE_NAME.privacyPolicy}`,
  ASSET: `/${PAGE_NAME.asset}`,
  SUBSCRIPTION: `/${PAGE_NAME.subscription}`,
  SEARCH_CHARACTER: `/${PAGE_NAME.searchRoom}/${PAGE_NAME.characterResult}`,
  SUBSCRIPTION_WAITING: `/${PAGE_NAME.subscriptionWaiting}`,
  TERMS: `/${PAGE_NAME.terms}`,
  PRIVACY: `/${PAGE_NAME.privacy}`,
  CHARACTER_DETAILS: `/${PAGE_NAME.characterDetails}`,
  EXPLORE: `/${PAGE_NAME.explore}`,
  MYSTERY: `/${PAGE_NAME.mystery}`,
  CHAT_CONCEPT: `/${PAGE_NAME.concept}`,
  MISSION_GAME: `/${PAGE_NAME.missionGame}`,
  MISSION_RESULT: `/${PAGE_NAME.missionGame}/${PAGE_NAME.missionResult}`,
  MISSION_CHAT: `/${PAGE_NAME.missionGame}/${PAGE_NAME.missionChat}`,
} as const;
